export default "__VITE_ASSET__CvHUNtvH__"